// extracted by mini-css-extract-plugin
export default {"trigger":"styles-module__trigger__src-labstep-web-components-UserGroupNotification-Action-UpdateMode-_nAWUt"};